module.exports = __webpack_public_path__ + "img/fiberharp.1c0200c4.jpg";